import React, { useEffect, useState } from 'react';

import { useCategoryState } from '@atlas/core';

const TopTournamentsContext = React.createContext();

export const TopTournamentsProvider = props => {
  const [topTournaments, setTopTournaments] = useState(null);
  const { initialized, loading, tournaments } = useCategoryState();
  const { children } = props;

  useEffect(() => {
    if (initialized && !loading) {
      setTopTournaments(tournaments);
    }
  }, [initialized, loading, tournaments]);

  return (
    <TopTournamentsContext.Provider value={topTournaments}>
      {children}
    </TopTournamentsContext.Provider>
  );
};

export const useTopTournamentsState = () => React.useContext(TopTournamentsContext);
